export { JumblesGameCoreModule } from './jumbles-game-core.module';
export { JumblesGameSelectorComponent } from './jumbles-game-selector/jumbles-game-selector.component';
export { JumblesGameCoreService } from './jumbles-game-core.service';
export { IJumbleGame } from './jumbles-game.interface';
